import { Injectable } from '@angular/core';
import { LogService } from "./log-servicios";
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class FechaHoraService {
  fechaActual: string;
  meses: string[];
  diasSem: string[];
  fAnioHoy: string = '';        //yyyy
  fMes0Hoy: number = 0;         //0-11
  fMesHoy: string = '';         //'01' a '12'
  fDiaHoy: string = '';         //'01' a '31'

  fAnio: string = '';           //yyyy
  fMes0: number = 0;            //0-11
  fMes: string = '';            //'01' a '12'
  fDia: string = '';            //'01' a '31'
  fDiaSem0: number = 0;         //0 (domingo) - 6 (sábado) 
  fNombreMes: string = '';      //'Enero', ...
  fAbrevDia: string = '';       //'L', M, Mi ...
  fPrimerLunesCal: number = 0;  // (23-31-1)
  fUltDiaMesAnt: number = 0;    // (28-31)
  fAbrevDia1: string = '';      // (D L...), 
  fUltDiaMes: number = 0;       // (28-31), 
  fAbrevUltDiaMes: string = ''; // (D L...), 
  fUltDomingoCal: number = 0;   // (28-31 1-6)
  fCantSemanas: number = 0;     // 4-5-6

  //datos para Citas
  //GYMD significa q la fecha viene en formato YYYY-MM-DD con guiones de separación
  fCitaLunesVisible: moment.Moment;             // Fecha del lunes de la semana visible 
  fCitaLunesVisibleAnio: string;                 // YYYY
  fCitaLunesVisibleMes0: number;                 // 0-11
  fCitaLunesVisibleNombreMes: string;            // 'Enero', ...
  fCitaLunesVisibleSemanas1900: number;          // Cant de semanas desde 1900-01-01
  fCitaDomingoVisible: moment.Moment;             // Fecha del domingo de la semana visible 
  fCitaDomingoVisibleAnio: string;                 // YYYY
  fCitaDomingoVisibleMes0: number;                 // 0-11
  fCitaDomingoVisibleNombreMes: string;            // 'Enero', ...
  fCitaSemanaVisibleNum: string[];                // ['22', '23', '24', '25', '26', '27', '28']

  //secuencial para asegurar que elementos creados el mismo milisegundo tengan un orden q no dependa del random
  //Empieza en 0. En la parte final, se suma 1 y se toman últimas 2 cifras y luego se une a un random de 4 cifras
  secuencial: number = 0;

  constructor(
    private logService: LogService
  ) { }

  formatFecha(fecha: Date): string {
    const d = new Date(fecha);
    let mm = "" + (d.getMonth() + 1);
    let dd = "" + d.getDate();
    const yyyy = d.getFullYear();
    if (mm.length < 2) mm = "0" + mm;
    if (dd.length < 2) dd = "0" + dd;
    return [yyyy, mm, dd].join("-");
  }

  formatHora(fecha: Date): string {
    const d = new Date(fecha);
    let h = "" + d.getHours();
    let m = "" + d.getMinutes();
    let s = "" + d.getSeconds();
    let ms = "" + d.getMilliseconds();
    if (h.length < 2) h = "0" + h;
    if (m.length < 2) m = "0" + m;
    if (s.length < 2) s = "0" + s;
    if (ms.length < 2) ms = "00" + ms;
    if (ms.length < 3) ms = "0" + ms;
    return [h, m, s, ms].join(":");
  }

  obtieneFechaActualGYMD(): string {
    this.fechaActual = moment(new Date()).format('YYYY-MM-DD');
    return this.fechaActual;
  }

  obtieneFechaActualSDMY(): string {
    this.fechaActual = moment(new Date()).format('DD/MM/YYYY');
    return this.fechaActual;
  }

  convierteFechaGYMD_SDMY(fGYMD: string): string {
    const yyyy = fGYMD.slice(0, 4);
    let mm = fGYMD.slice(5, 7);
    let dd = fGYMD.slice(8);
    if (dd.length < 2) dd = "0" + dd;
    if (mm.length < 2) mm = "0" + mm;
    return [dd, mm, yyyy].join("/");
  }

  convierteFechaSDMY_GYMD(fSDMY: string): string {
    let dd = fSDMY.slice(0, 2);
    let mm = fSDMY.slice(3, 5);
    const yyyy = fSDMY.slice(6);
    if (dd.length < 2) dd = "0" + dd;
    if (mm.length < 2) mm = "0" + mm;
    return [yyyy, mm, dd].join("-");
  }

  obtieneRandomFechaHora(): string {
    const f: string = moment(new Date()).format('YYYYMMDD_HHmmss_SSS_')
      + (this.secuencial++ % 100).toFixed(0).padStart(2, '0')
      + (Math.random() * 10000).toFixed(0).padStart(4, '0');
    return f;
  }

  diasEntreFechasStr(F1: string, F2: string): number {
    //las fechas vienen en formato  YYYY-MM-DD
    const a = moment(F1);
    const b = moment(F2);
    return a.diff(b, 'days');
  }

  preparaBasicoFecha() {
    moment.locale('es');
    this.meses = moment.months();
    for (let i = 0; i < this.meses.length; i++) {
      this.meses[i] = this.meses[i].substring(0, 1).toUpperCase() + this.meses[i].substring(1, this.meses[i].length);
    }
    this.diasSem = ['D', 'L', 'M', 'Mi', 'J', 'V', 'S'];
  }

  datosCalendario(pFechaGYMD: string) {
    this.preparaBasicoFecha();
    //GYMD significa q la fecha viene en formato YYYY-MM-DD con guiones de separación
    this.logService.consoleLog('2', 'CS FH pFechaGYMD: ' + pFechaGYMD);

    this.fAnioHoy = moment(new Date()).year().toString();
    this.fMes0Hoy = (moment(new Date()).month());
    this.fMesHoy = (this.fMes0Hoy + 1).toString();
    if (this.fMesHoy.length < 2) this.fMesHoy = "0" + this.fMesHoy;
    this.fDiaHoy = moment(new Date()).date().toString();
    if (this.fDiaHoy.length < 2) this.fDiaHoy = "0" + this.fDiaHoy;
    this.logService.consoleLog('2', 'CS FH Hoy: ' + this.fAnioHoy + '-' + this.fMesHoy + '-' + this.fDiaHoy);

    this.fAnio = moment(pFechaGYMD, "YYYY-MM-DD").year().toString();
    this.fMes0 = (moment(pFechaGYMD, "YYYY-MM-DD").month());
    this.fMes = (this.fMes0 + 1).toString();
    if (this.fMes.length < 2) this.fMes = "0" + this.fMes;
    this.fDia = moment(pFechaGYMD, "YYYY-MM-DD").date().toString();
    if (this.fDia.length < 2) this.fDia = "0" + this.fDia;
    this.fDiaSem0 = moment(pFechaGYMD, "YYYY-MM-DD").day();
    this.fNombreMes = this.meses[this.fMes0];
    this.fAbrevDia = this.diasSem[this.fDiaSem0];
    this.logService.consoleLog('2', 'CS FH fecha: ' + this.fAnio + '-' + this.fMes + '-' + this.fDia + ' ' + this.fNombreMes + ' ' + this.fAbrevDia);

    //Día de la semana del día 1 de este mes
    const dia1: moment.Moment = moment(this.fAnio + '-' + this.fMes + '-01', "YYYY-MM-DD");
    this.fAbrevDia1 = this.diasSem[dia1.day()];

    //Primer lunes del calendario (puede ir desde 23 hasta 31, y si el mes empieza el lunes es el 1)
    const primerLunesCal: moment.Moment = moment(this.fAnio + '-' + this.fMes + '-01', "YYYY-MM-DD");
    if (this.fAbrevDia1 == 'L') {
      //primerLunesCal = dia1;
    } else if (this.fAbrevDia1 == 'D') {
      primerLunesCal.subtract(6, 'days')
    } else {
      primerLunesCal.subtract(dia1.day() - 1, 'days')
    }
    this.fPrimerLunesCal = primerLunesCal.date();

    //Ultimo día del mes anterior
    const ultDiaMesAnt: moment.Moment = moment(this.fAnio + '-' + this.fMes + '-01', "YYYY-MM-DD");
    ultDiaMesAnt.subtract(1, 'days');
    this.fUltDiaMesAnt = ultDiaMesAnt.date();

    //Ultimo día de este mes
    let proxMes: string = (this.fMes0 + 2).toString();
    if (proxMes == '13') proxMes = "01";
    if (proxMes.length < 2) proxMes = "0" + proxMes;
    const proxAnio: string = proxMes == '01' ? (parseInt(this.fAnio) + 1).toString() : this.fAnio;
    const ultDiaMes: moment.Moment = moment(proxAnio + '-' + proxMes + '-01', "YYYY-MM-DD").subtract(1, 'days');
    this.fUltDiaMes = ultDiaMes.date();

    //Abrev último día del mes
    this.fAbrevUltDiaMes = this.diasSem[ultDiaMes.day()];

    //Ultimo domingo del calendario
    let ultDomingoCal: moment.Moment = ultDiaMes;
    if (this.fAbrevUltDiaMes == 'D') {
      ultDomingoCal = ultDiaMes;
    } else {
      ultDomingoCal = ultDomingoCal.add(7 - ultDiaMes.day(), 'days');
    }
    this.fUltDomingoCal = ultDomingoCal.date();

    //Cantidad de semanas en el calendario:
    this.fCantSemanas = (ultDomingoCal.diff(primerLunesCal, 'days') + 1) / 7;

    this.logService.consoleLog('2', 'CS FH otros: ' + this.fPrimerLunesCal + ' ' + this.fUltDiaMesAnt + ' ' + this.fAbrevDia1);
    this.logService.consoleLog('2', 'CS FH otros: ' + this.fUltDiaMes + ' ' + this.fAbrevUltDiaMes + ' ' + this.fUltDomingoCal + ' ' + this.fCantSemanas);
  }

  mover7Izq(pFechaGYMD: string): string {
    //devuelve pFechaGYMD menos 7 días. Tanto el parám como la respuesta son en formato "YYYY-MM-DD"
    return moment(pFechaGYMD, "YYYY-MM-DD").subtract(7, 'days').format("YYYY-MM-DD");
  }

  mover7Der(pFechaGYMD: string): string {
    //devuelve pFechaGYMD menos 7 días. Tanto el parám como la respuesta son en formato "YYYY-MM-DD"
    return moment(pFechaGYMD, "YYYY-MM-DD").add(7, 'days').format("YYYY-MM-DD");
  }

  obtieneNumMes(mesTexto: string): string {
    this.logService.consoleLog('2', 'CS FH mesTexto: ' + mesTexto);
    let mesNum: string = '00';
    for (let i = 0; i < this.meses.length; i++) {
      if (this.meses[i] == mesTexto) {
        mesNum = (i + 1).toString();
        if (mesNum.length == 1) {
          mesNum = '0' + mesNum;
          this.logService.consoleLog('2', 'CS FH mesNum: ' + mesNum);
        }
      }
    }
    return mesNum;
  }

  obtieneEdad(ymd: string): string {
    const a = moment(ymd);
    if (Number.isNaN(moment().diff(a, 'years'))) {
      return '--';
    } else {
      const edad: string = (moment().diff(a, 'years')).toString();
      return edad;
    }
  }

  datosSemana(pFechaGYMD: string) {
    //GYMD significa q la fecha viene en formato YYYY-MM-DD con guiones de separación
    this.logService.consoleLog('2', 'CS FH pFechaGYMD: ' + pFechaGYMD);
    this.preparaBasicoFecha();

    /*
    this.fAnioHoy = moment(new Date()).year().toString();
    this.fMes0Hoy = (moment(new Date()).month());
    this.fMesHoy = (this.fMes0Hoy + 1).toString();
    if (this.fMesHoy.length < 2) this.fMesHoy = "0" + this.fMesHoy;
    this.fDiaHoy = moment(new Date()).date().toString();
    if (this.fDiaHoy.length < 2) this.fDiaHoy = "0" + this.fDiaHoy;
    this.logService.consoleLog('2', 'CS FH Hoy: ' + this.fAnioHoy + '-' + this.fMesHoy + '-' + this.fDiaHoy);

    this.fAnio = moment(pFechaGYMD, "YYYY-MM-DD").year().toString();
    this.fMes0 = (moment(pFechaGYMD, "YYYY-MM-DD").month());
    this.fMes = (this.fMes0 + 1).toString();
    if (this.fMes.length < 2) this.fMes = "0" + this.fMes;
    this.fDia = moment(pFechaGYMD, "YYYY-MM-DD").date().toString();
    if (this.fDia.length < 2) this.fDia = "0" + this.fDia;
    */
    this.fDiaSem0 = moment(pFechaGYMD, "YYYY-MM-DD").day();
    //this.fNombreMes = this.meses[this.fMes0];
    this.fAbrevDia = this.diasSem[this.fDiaSem0];
    //this.logService.consoleLog('2', 'CS FH fecha: ' + this.fAnio + '-' + this.fMes + '-' + this.fDia + ' ' + this.fNombreMes + ' ' + this.fAbrevDia);

    //fecha del lunes de esta semana:
    let r1: number = 0
    let r2: number = 0

    switch (this.fAbrevDia) {
      case 'L':
        r1 = 0;
        r2 = 6;
        break;
      case 'M':
        r1 = 1;
        r2 = 5;
        break;
      case 'Mi':
        r1 = 2;
        r2 = 4;
        break;
      case 'J':
        r1 = 3;
        r2 = 3;
        break;
      case 'V':
        r1 = 4;
        r2 = 2;
        break;
      case 'S':
        r1 = 5;
        r2 = 1;
        break;
      case 'D':
        r1 = 6;
        r2 = 0;
        break;
      default:
        break;
    }
    this.fCitaLunesVisible = moment(pFechaGYMD, 'YYYY-MM-DD').subtract(r1, 'days');
    this.fCitaLunesVisibleAnio = this.fCitaLunesVisible.year().toString();
    this.fCitaLunesVisibleMes0 = this.fCitaLunesVisible.month();
    this.fCitaLunesVisibleNombreMes = this.meses[this.fCitaLunesVisibleMes0];
    this.fCitaLunesVisibleSemanas1900 = this.obtieneCantSemanas1900(pFechaGYMD);
    this.fCitaDomingoVisible = moment(pFechaGYMD, 'YYYY-MM-DD').add(r2, 'days');
    this.fCitaDomingoVisibleAnio = this.fCitaDomingoVisible.year().toString();
    this.fCitaDomingoVisibleMes0 = this.fCitaDomingoVisible.month();
    this.fCitaDomingoVisibleNombreMes = this.meses[this.fCitaDomingoVisibleMes0];
    this.fCitaSemanaVisibleNum = [];
    const a: moment.Moment = moment(pFechaGYMD, 'YYYY-MM-DD').subtract(r1, 'days');
    this.fCitaSemanaVisibleNum.push(a.date().toString());
    for (let i = 1; i <= 6; i++) {
      this.fCitaSemanaVisibleNum.push(a.add(1, 'days').date().toString());
    }

  }

  obtieneCantSemanas1900(pFechaGYMD: string) {
    //devuelve la cant de semanas enteras desde el 1/1/1900. El 1/1/1900 fue lunes. 
    //hasta el 7/1/1900 da 0. Desde el 8/1/1900 es semana 1 y así.
    //Este valor se graba en cada cita para buscar fácilmente por semanas
    let sems: number = 0;
    //estaba usando moment.js para calcular, pero falla con un día desde el 23/11/1914, no sé por qué.
    //da el error tanto usando la función weeks como days
    //es decir, desde esa fecha, el lunes lee una semana menos y el martes ya lee bien
    /*
    const fBase: string = '1900-01-01';
    const a = moment(pFechaGYMD, "YYYYMMDD");
    const b = moment(fBase, "YYYYMMDD");
    const c: number = a.diff(b, 'days');
    const d: number = c / 7;
    const e: number = Math.floor(d);
    */
    //Uso Date que no da el error
    const a1 = new Date(pFechaGYMD).getTime();
    const b1 = new Date('1900-01-01').getTime();
    const diff: number = (a1 - b1) / (1000 * 60 * 60 * 24);
    const diff2 = Math.floor(diff);
    const wee = Math.floor(diff2 / 7);
    sems = wee;
    return sems;
  }

  obtieneHoraActualDecimal(): number {
    const h: string = moment(new Date()).format('HHmm');
    let hd: number = 0;
    hd = parseInt(h.slice(0, 2)) + parseInt(h.slice(2)) / 60
    return hd;
  }

  obtieneDiaSemFechaGYMD(pFechaGYMD: string): number {
    //devuelve el número de día de la semana basado en lunes=0, domingo=6
    //day se basa en domingo=0, es decir devuelve 0 para domingo y 6 para sábado, 
    //pero quiero que sea basado en lunes, por eso resto 1
    let d = moment(pFechaGYMD, "YYYY-MM-DD").day() - 1;
    //si era domingo al restar 1 da -1, le convierto en 6
    d = d == -1 ? 6 : d;
    return d;
  }

  obtieneNombreDiaFechaGYMD(pFechaGYMD: string): string {
    //devuelve el nombre del día de la fecha indicada, de lunes (0) a domingo (6)
    let d = moment(pFechaGYMD, "YYYY-MM-DD").day() - 1;
    const nombres: string[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']
    //si era domingo al restar 1 da -1, le convierto en 6
    d = d == -1 ? 6 : d;
    return nombres[d];
  }
}
